export const USER_DATA_STORAGE_KEY = "user_data";
export const USER_DATA_UPDATED_EVENT = "user-data-updated";

const SENSITIVE_FIELDS = [
	"password",
	"password_confirmation",
	"current_password",
	"old_password",
	"new_password",
];

export function getUserData() {
	try {
		const raw = localStorage.getItem(USER_DATA_STORAGE_KEY);
		if (!raw || raw === "null") return null;
		return JSON.parse(raw);
	} catch {
		return null;
	}
}

function stripSensitiveFields(data) {
	if (!data || typeof data !== "object") return data;
	const next = { ...data };
	SENSITIVE_FIELDS.forEach((field) => delete next[field]);
	return next;
}

function isUserShape(data) {
	return (
		data &&
		typeof data === "object" &&
		"id" in data &&
		("email" in data || "name" in data || "roles" in data || "super_admin" in data)
	);
}

export function normalizeUserPayload(payload) {
	if (!payload || typeof payload !== "object") return null;

	if (payload.user && isUserShape(payload.user)) {
		return stripSensitiveFields(payload.user);
	}

	if (payload.data && isUserShape(payload.data)) {
		return stripSensitiveFields(payload.data);
	}

	if (isUserShape(payload)) {
		return stripSensitiveFields(payload);
	}

	return null;
}

export function mergeUserData(current, updates) {
	if (!current) return updates || {};
	if (!updates) return current;

	const merged = {
		...current,
		...updates,
	};

	if (current.company || updates.company) {
		merged.company = {
			...(current.company || {}),
			...(updates.company || {}),
		};
	}

	if (current.warehouse || updates.warehouse) {
		merged.warehouse = {
			...(current.warehouse || {}),
			...(updates.warehouse || {}),
		};
	}

	return merged;
}

export function persistUserData(partialOrFull, { replace = false } = {}) {
	const normalized = normalizeUserPayload(partialOrFull);
	const payload = normalized || stripSensitiveFields(partialOrFull);
	const current = getUserData();
	const next = replace ? payload : mergeUserData(current, payload);

	if (!next || typeof next !== "object") return current;

	localStorage.setItem(USER_DATA_STORAGE_KEY, JSON.stringify(next));
	window.dispatchEvent(
		new CustomEvent(USER_DATA_UPDATED_EVENT, { detail: next }),
	);

	return next;
}

export function clearUserData() {
	localStorage.removeItem(USER_DATA_STORAGE_KEY);
	window.dispatchEvent(
		new CustomEvent(USER_DATA_UPDATED_EVENT, { detail: {} }),
	);
}
